import { Button, Box, Heading, Page, PageContent, Text } from 'grommet';
import { FormPreviousLink } from 'grommet-icons';
import QueryString from 'qs';
import React from 'react';
import { useLoaderData, useNavigate, useParams } from 'react-router-dom';
import { API } from '@enrich/shared-lib';
import { ContactMessage } from './ContactMessages';

export const ContactConversations = () => {
    const navigate = useNavigate();
    const params = useParams();
    const messages = useLoaderData();

    return (
        <Page>
            <PageContent>
                <Box direction="row" justify="between" pad={{ right: 'small' }}>
                    <Heading level="2">Message History</Heading>
                    <Button
                        onClick={() =>
                            navigate(`/contacts/${params.contactId}`)
                        }>
                        <Box direction="row">
                            <FormPreviousLink color="black" />
                            <Text>Back to profile</Text>
                        </Box>
                    </Button>
                </Box>
                <Box gap="small">
                    {messages.map((message) => {
                        return (
                            <ContactMessage
                                contactId={params.contactId}
                                message={message}
                                key={message.id}
                            />
                        );
                    })}
                </Box>
            </PageContent>
        </Page>
    );
};

export async function loader(params) {
    const contactId = params.params.contactId;
    const query = QueryString.stringify({
        filters: {
            $or: [
                {
                    sender: {
                        contact: contactId,
                    },
                },
                {
                    recipients: {
                        contact: contactId,
                    },
                },
            ],
        },
        populate: {
            sender: {
                populate: ['contact'],
            },
        },
        sort: ['createdAt:desc'],
    });

    try {
        const response = await API.get(`/api/messages?${query}`);
        return response.data.data;
    } catch (error) {
        console.log(error);
    }
}
